import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, firstValueFrom } from 'rxjs';
import config from '../../../../config';
import { Profile } from '../models/profile';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly serverURL = `${config.API_ENDPOINT}/api`;
  private profileSubject = new ReplaySubject<Profile>(1);
  private profileLoaded = false;

  constructor(private http: HttpClient) {}

  getProfile(forceRefresh = false): Observable<Profile> {
    if (!this.profileLoaded || forceRefresh) {
      this.profileLoaded = true;
      this.loadProfile().subscribe({
        next: (profile) => this.profileSubject.next(profile),
        error: (error) => {
          this.profileLoaded = false;
          this.profileSubject.error(error);
          this.profileSubject = new ReplaySubject<Profile>(1);
        },
      });
    }

    return this.profileSubject.asObservable();
  }

  //registerNgsProfile(): Promise<void> {
  //  const url = `${this.serverURL}/profile/registerNgsProfile`;
  //  return firstValueFrom(this.http.post<void>(url, null));
  //}

  private loadProfile(): Observable<Profile> {
    return this.http.get<Profile>(`${this.serverURL}/profile`);
  }
}
